module.exports = __webpack_public_path__ + "img/btn-arrow.ad091771.svg";